/** My Voices (owner session cookie): private singing-voice models trained on your Replicate account. */
import axios from "axios";
import { API } from "@/lib/creatorApi";
import { chunkedUpload } from "@/lib/chunkedUpload";

const http = axios.create({ baseURL: `${API}/my-voices`, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const getStatus = () => data(http.get("/status"));
export const listVoices = () => data(http.get(""));
export const createVoice = (body) => data(http.post("", body));
export const getVoice = (id) => data(http.get(`/${id}`));
export const patchVoice = (id, body) => data(http.patch(`/${id}`, body));
export const selectVoice = (id) => data(http.post(`/${id}/select`));
export const setActiveVersion = (id, versionId) => data(http.post(`/${id}/active-version`, { version_id: versionId }));
export const deleteVoice = (id) => data(http.delete(`/${id}`));

export const listClips = (id) => data(http.get(`/${id}/clips`));
export const clipFromEnhance = (id, enhanceId) => data(http.post(`/${id}/clips/from-enhance`, { enhance_id: enhanceId }));
export const clipFromTake = (id, sessionId, takeId) => data(http.post(`/${id}/clips/from-take`, { session_id: sessionId, take_id: takeId }));
export const retryClip = (id, clipId) => data(http.post(`/${id}/clips/${clipId}/retry`));
export const deleteClip = (id, clipId) => data(http.delete(`/${id}/clips/${clipId}`));
export const clipAudioUrl = (id, clipId) => `${API}/my-voices/${id}/clips/${clipId}/audio`;
export const uploadClip = (id, file, isolate, onProgress) => chunkedUpload(http, {
  start: `/${id}/clips/uploads`, chunk: (cid, i) => `/${id}/clips/uploads/${cid}/chunks/${i}`, finish: (cid) => `/${id}/clips/uploads/${cid}/finish`,
}, file, { filename: file.name, size: file.size }, { isolate: Boolean(isolate) }, onProgress);

export const listVersions = (id) => data(http.get(`/${id}/versions`));
export const trainVoice = (id, quality) => data(http.post(`/${id}/train`, { quality }));
export const cancelVersion = (id, vid) => data(http.post(`/${id}/versions/${vid}/cancel`));
export const deleteVersion = (id, vid) => data(http.delete(`/${id}/versions/${vid}`));
export const makePreview = (id, vid, body) => data(http.post(`/${id}/versions/${vid}/previews`, body));
export const deletePreview = (id, pid) => data(http.delete(`/${id}/previews/${pid}`));
export const previewAudioUrl = (id, pid, which) => `${API}/my-voices/${id}/previews/${pid}/${which}.mp3`;

export const VERSION_ACTIVE = ["preparing", "training", "saving"];
export const PREVIEW_ACTIVE = ["preparing", "converting", "saving"];
export const VERSION_PHASE = { queued: "Getting ready", packing: "Packing your recordings", starting: "Starting on Replicate (a GPU is warming up)", training: "Training your voice", saving: "Saving your model" };
export const mins = (s) => `${((s || 0) / 60).toFixed(1)} min`;
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "");
